module.exports = __webpack_public_path__ + "static/img/31.b81e722c.png";